// extracted by mini-css-extract-plugin
module.exports = {"Table":"Table_Table__5K-gx"};